export const CAREER_FORM_SUBMISSION_PATH = "/api/career-form-submission-datas";
export const HOMEPAGE_FORM_SUBMISSION_PATH =
    "/api/homepage-form-submission-datas";

export type HeaderContactAction =
    | "scroll-to-career-form"
    | "open-homepage-overlay";

function normalizePathname(pathname: string) {
    const withoutHash = pathname.split("#")[0] ?? "";
    const withoutQuery = withoutHash.split("?")[0] ?? "";
    if (withoutQuery.length > 1 && withoutQuery.endsWith("/")) {
        return withoutQuery.slice(0, -1);
    }
    return withoutQuery;
}

export function isCareersPath(pathname: string) {
    const path = normalizePathname(pathname);
    return path === "/careers" || path.startsWith("/careers/");
}

// Homepage contact form (page section and header overlay). Career pages
// must not write into the homepage collection.
export function getContactFormSubmissionPath(pathname: string) {
    return isCareersPath(pathname)
        ? CAREER_FORM_SUBMISSION_PATH
        : HOMEPAGE_FORM_SUBMISSION_PATH;
}

export function getHeaderContactAction(pathname: string): HeaderContactAction {
    return isCareersPath(pathname)
        ? "scroll-to-career-form"
        : "open-homepage-overlay";
}
